import { render, staticRenderFns } from "./DrawBoundingBox.vue?vue&type=template&id=132c4ae0&"
import script from "./DrawBoundingBox.vue?vue&type=script&lang=js&"
export * from "./DrawBoundingBox.vue?vue&type=script&lang=js&"
import style0 from "./DrawBoundingBox.vue?vue&type=style&index=0&id=132c4ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports